/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoGenerateTokenInput = {
    clientMutationId?: string | null;
    slug: string;
};
export type GenerateTokenDialogMutationVariables = {
    input: infoGenerateTokenInput;
};
export type GenerateTokenDialogMutationResponse = {
    readonly infoGenerateToken: {
        readonly clientMutationId: string | null;
        readonly user: {
            readonly accessToken: string | null;
        };
    } | null;
};
export type GenerateTokenDialogMutation = {
    readonly response: GenerateTokenDialogMutationResponse;
    readonly variables: GenerateTokenDialogMutationVariables;
};



/*
mutation GenerateTokenDialogMutation(
  $input: infoGenerateTokenInput!
) {
  infoGenerateToken(input: $input) {
    clientMutationId
    user {
      accessToken
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoGenerateTokenPayload",
    "kind": "LinkedField",
    "name": "infoGenerateToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accessToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateTokenDialogMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenerateTokenDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8573e218cfd58f07df1c033117e7b9cf",
    "id": null,
    "metadata": {},
    "name": "GenerateTokenDialogMutation",
    "operationKind": "mutation",
    "text": "mutation GenerateTokenDialogMutation(\n  $input: infoGenerateTokenInput!\n) {\n  infoGenerateToken(input: $input) {\n    clientMutationId\n    user {\n      accessToken\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'df22e588cbaf7236a4a48126b9590f54';
export default node;
